import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import type { Story } from '../../data/stories';

interface StoryCardProps {
  story: Story;
  index?: number;
}

export default function StoryCard({ story, index = 0 }: StoryCardProps) {
  return (
    <motion.div
      className="story-card"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <div className="story-card-content">
        <h3 style={{ fontSize: 'clamp(1.125rem, 3vw, 1.5rem)' }}>{story.name}, {story.age}</h3>
        <p style={{ color: 'var(--text-light)', fontSize: 'clamp(0.8125rem, 2vw, 0.95rem)', marginBottom: '1rem' }}>
          {story.journey}
        </p>
        <p style={{ fontStyle: 'italic', color: 'var(--text)', flex: 1, fontSize: 'clamp(0.875rem, 2vw, 1rem)' }}>
          "{story.shortQuote}"
        </p>
        <Link
          to={`/stories/${story.id}`}
          style={{
            fontWeight: 600,
            color: 'var(--accent)',
            marginTop: '1rem',
            display: 'inline-block',
            fontSize: 'clamp(0.875rem, 2vw, 1rem)'
          }}
        >
          Read More →
        </Link>
      </div>
    </motion.div>
  );
}
